export enum AnnotatorSelectionMode {
  Addition,
  Intersection,
  New,
  Subtraction,
}
